exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2BkXt{position:absolute;z-index:50;top:0;right:0;bottom:0;left:0;background-color:#000}._2BkXt,._2BkXt video{width:100%;height:100%}._2BkXt video{position:relative;z-index:0}._378gi,.KiGq3{position:absolute;z-index:1;right:0;left:0;visibility:hidden;height:182px;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;opacity:0;background-size:100% 182px}._378gi.CHkoC,.KiGq3.CHkoC{visibility:visible;opacity:1}._378gi{top:0;background-image:-webkit-gradient(linear,left bottom,left top,from(transparent),color-stop(24%,rgba(0,0,0,.03)),color-stop(50%,rgba(0,0,0,.15)),color-stop(75%,rgba(0,0,0,.3)),to(rgba(0,0,0,.4)));background-image:linear-gradient(0deg,transparent,rgba(0,0,0,.03) 24%,rgba(0,0,0,.15) 50%,rgba(0,0,0,.3) 75%,rgba(0,0,0,.4))}.KiGq3{bottom:0;background-image:-webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(24%,rgba(0,0,0,.03)),color-stop(50%,rgba(0,0,0,.15)),color-stop(75%,rgba(0,0,0,.3)),to(rgba(0,0,0,.4)));background-image:linear-gradient(180deg,transparent,rgba(0,0,0,.03) 24%,rgba(0,0,0,.15) 50%,rgba(0,0,0,.3) 75%,rgba(0,0,0,.4))}", ""]);

// exports
exports.locals = {
	"screen": "_2BkXt",
	"screenTopBackground": "_378gi",
	"screenBottomBackground": "KiGq3",
	"visible": "CHkoC"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--9-1!../node_modules/postcss-loader/lib??ref--9-2!../node_modules/sass-loader/lib/loader.js??ref--9-3!./default-modules/ui/screen/screen.scss
// module id = 135
// module chunks = 0 1 2 3 4